import {
  BUSINESS_STATUS_CLOSED_NOW,
  BUSINESS_STATUS_CLOSING_SOON,
  BUSINESS_STATUS_OPEN_NOW,
  BUSINESS_STATUS_OPENS_SOON,
} from './constants';
import type { BusinessStatusConfigMap, BusinessStatusList } from './types';

export const businessStatusList: BusinessStatusList = [
  BUSINESS_STATUS_CLOSED_NOW,
  BUSINESS_STATUS_CLOSING_SOON,
  BUSINESS_STATUS_OPEN_NOW,
  BUSINESS_STATUS_OPENS_SOON,
];

export const businessStatusConfigMap: BusinessStatusConfigMap = {
  [BUSINESS_STATUS_CLOSED_NOW]: {
    text: 'Closed now',
    className: 'isClosedNow',
  },
  [BUSINESS_STATUS_CLOSING_SOON]: {
    text: 'Closing soon',
    className: 'isClosingSoon',
  },
  [BUSINESS_STATUS_OPEN_NOW]: {
    text: 'Open now',
    className: 'isOpenNow',
  },
  [BUSINESS_STATUS_OPENS_SOON]: {
    text: 'Opens soon',
    className: 'isOpensSoon',
  },
};
